import { createSlice } from '@reduxjs/toolkit'

const comment = (json) => ({
  "id": json["id"] || "",
  "name": json["name"] || "",
  "date": json["date"] || "",
  "content": json["content"] || "",
  "approved": json["approved"] || false,
});

let preparer = (payload, meta) => ({
  payload, meta
});

export const commentsSlice = createSlice({
  name: 'comments',
  initialState: {
  },
  reducers: {
    loading: {
      prepare: preparer,
      reducer: (state, action) => {
        state[action.meta.id] = {
          ...state[action.meta.id],
          loading: true,
        };
      }
    },
    error: {
      prepare: preparer,
      reducer: (state, action) => {
        state[action.meta.id] = {
          ...state[action.meta.id],
          loading: false,
          comments: [],
        };
      }
    },
    success: {
      prepare: preparer,
      reducer: (state, action) => {
        state[action.meta.id] = {
          loading: false,
          comments: action.payload.items.map(comment)
        };
      }
    }
  }
});

export const actions = commentsSlice.actions;

export default commentsSlice.reducer;